/* eslint-disable react/no-danger */
import FreelancerSelfEmployedIndustryPage from "@components/FreelancerSelfEmployedIndustryPage";
import validatePaidCampaign from "@helpers/validatePaidCampaign";
import axios from "axios";
import dynamic from "next/dynamic";
import React, { Component } from "react";
import { animateScroll as scroll } from "react-scroll";
import FooterComponent from "@/components/Footer/FooterComponent";
import Header from "@/components/Header/Header";
import SEOHead from "@/components/SEOHead/SEOHead";
import { WordPressAPI } from "../../../config";
import parse from "html-react-parser";

const FooterNewsModal = dynamic(import("@/components/FooterNewsModal"));

class FreelancerSelfEmployed extends Component {
  state = {
    isSchedulerOpen: false,
    PaidCampaign: 1,
    hideSchedulerHeader: false,
  };

  componentDidUpdate() {
    if (this.state.isSchedulerOpen) {
      document.body.classList.add("no-overflow");
    } else {
      document.body.classList.remove("no-overflow");
    }
  }

  scrollUp = () => {
    scroll.scrollToTop({
      duration: 250,
    });
  };

  toggleIsSchedulerOpen = () => {
    this.setState((prevState) => ({
      isSchedulerOpen: !prevState.isSchedulerOpen,
      hideSchedulerHeader: !prevState.isSchedulerOpen,
    }));
  };

  render() {
    const { data } = this.props;
    const { title, acf } = this.props.data;
    const paid_campaign = validatePaidCampaign(acf.paid_campaign);
    const { additional_questions } = acf;

    return (
      <div>
        <Header
          AdditionalQuestions={additional_questions}
          PaidCampaign={
            typeof paid_campaign === "undefined" ? 1 : paid_campaign
          }
          phone_number={acf.phone_number_setup}
          leadValues={acf.lead_values}
          hideSchedulerHeader={this.state.hideSchedulerHeader}
        />
        <SEOHead>
          <title>{acf?.page_title_tag}</title>
          <meta
            name="description"
            content={acf?.meta_description || ""}
            key="description"
          />
          <script
            type="text/javascript"
            src="//app-ab33.marketo.com/js/forms2/js/forms2.min.js"
          />

          {parse(`
            <script type="application/ld+json">
            {
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": [{
                "@type": "Question",
                "name": "Do freelancers have to register as a business?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Freelancers aren't required to register as a business but open themselves up to numerous advantages when they do. Make your freelance business official via our free (+ state fees) <a href='https://1800accountant.com/services/entity-formation/location'>entity formation process</a>."
                }
              },{
                "@type": "Question",
                "name": "How do I pay taxes when I'm self-employed?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Typically, you are required to file an annual return and pay an estimated tax quarterly. You have to file an income tax return if your net earnings from self-employment are $400 or more. If your net earnings from self-employment were less than $400, you still have to file an income tax return if you meet any other filing requirement listed in Form 1040 and 1040-SR."
                }
              }]
            }
            </script>                                               
            `)}
        </SEOHead>
        <FreelancerSelfEmployedIndustryPage
          data={acf}
          isSchedulerOpen={this.state.isSchedulerOpen}
          toggleIsSchedulerOpen={this.toggleIsSchedulerOpen}
        />
        <FooterNewsModal />
        <FooterComponent phone_number={acf.phone_number_setup} />
      </div>
    );
  }
}

export const getStaticProps = async () => {
  const pageId =
    process.env.NEXT_PUBLIC_WORDPRESS == "https://staging1800a.wpengine.com"
      ? "20755"
      : "20915";
  const { data } = await axios.get(`${WordPressAPI.pages}/${pageId}`);

  return {
    props: {
      data,
    },
    // revalidate: 1,
  };
};

export default FreelancerSelfEmployed;
